var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.87988 19.43L3.07988 20.63L5.94488 19.975L6.14988 19.925L8.30488 19.425L20.8599 6.87002L15.6449 1.65002L3.08488 14.21L1.87988 19.43ZM7.69988 18.335L5.53488 18.835C5.01167 18.152 4.37387 17.5649 3.64988 17.1L4.17988 14.815L4.41488 14.58C5.72207 15.6056 6.90507 16.7802 7.93988 18.08L7.69988 18.335ZM15.6449 3.35002L5.27488 13.72C6.57285 14.7617 7.75318 15.9421 8.79488 17.24L19.1449 6.85002L15.6449 3.35002Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0399 20.9H6.03988V22.1H21.0399V20.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c4634e5d07d1a53ffe4c3f3029d5a264.svg";
export { ForwardRef as ReactComponent };